import {KpiInfo, ValidationError, Validator} from "../../../../../types/types";
import {StringUtils} from "../../../../../utils/stringUtils";

export class SchedulerConfigurationValidator implements Validator<KpiInfo> {

    validate(kpiInfo: KpiInfo): ValidationError[] {
        const validationErrors = [];
        const aggregationLength = kpiInfo.aggregationNames.length;
        if (aggregationLength < 1 && StringUtils.isEmpty(kpiInfo.cron)) {
            validationErrors.push(new ValidationError("scheduler", `Please select atleast one dependent aggregation or schedule it`));
        }
        return validationErrors;
    }


}

